module.exports = "/images/smallArrowDown.png?6f4cff00e0ec09f8e82a85ccb2f2ab0c";